import AppConfig from "util/AppConfig";
import { archiveRetentionCellText } from "./archiveRetention";
export const ARCHIVE_RETENTION_ATTRIBUTE_ID = "archive_retention";
const indexSetArchiveRetentionColumn = {
  attributeName: ARCHIVE_RETENTION_ATTRIBUTE_ID,
  group: "configuration",
  backendAttributeIds: [ARCHIVE_RETENTION_ATTRIBUTE_ID],
  columnRenderers: {
    [ARCHIVE_RETENTION_ATTRIBUTE_ID]: {
      renderCell: (days) => archiveRetentionCellText(days),
      staticWidth: "matchHeader",
      textAlign: "right"
    }
  }
};
export const indexSetArchiveRetentionTableElements = () => AppConfig.isCloud() ? [] : [indexSetArchiveRetentionColumn];
export default indexSetArchiveRetentionColumn;
